module.exports = __webpack_public_path__ + "img/dialog-close.0438bd0f.svg";